import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const FECHA_INICIO_POR_DEFECTO = () =>
    moment().add(1, 'month').startOf('month').format('yyyy-MM-DD');

const initialState = {
    defaultEntity: {
        id: 0,
        numero: 0,
        idTerapia: 0,
        idTerapeuta: 0,
        terapeuta: "",
        idParticipante: 0,
        participante: "",
        // Periodicidad del plan (catalogo 300). Con la fecha de inicio define
        // la fecha de fin, igual que en el mantenimiento de periodos.
        idPeriodicidad: 303,
        periodicidad: "Mensual",
        fechaInicio: FECHA_INICIO_POR_DEFECTO(),
        fechaFin: moment().format('yyyy-MM-DD'),
        idEstadoVigencia: 91,
        estadoVigencia: "Vigente",
        idEstado: 2,
        estado: "Activo",
        idPuntuacionPlanificacion: 2,
        puntuacionPlanificacion: "PCC",
        idPuntuacionAvance: 1,
        puntuacionAvance: "PCS",
        // Modelo y area sugeridos del plan (opcionales).
        idModelo: 0,
        codigoModelo: "",
        modelo: "",
        idArea: 0,
        codigoArea: "",
        area: "",
        areaModelo: [],
        // Indicadores de detalle del criterio en la sesion (Si/No).
        // Un plan nuevo arranca en No: el detalle de objetivo y de criterio es
        // opcional y lo activa el terapeuta si lo necesita.
        detObjetivo: false,
        detCriterio: false,
        observaciones: "",
        // Texto libre que se muestra en el reporte trimestral del plan.
        enunciadoReporte: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        numero: 0,
        idTerapia: 0,
        idTerapeuta: 0,
        terapeuta: "",
        idParticipante: 0,
        participante: "",
        idPeriodicidad: 303,
        periodicidad: "Mensual",
        fechaInicio: FECHA_INICIO_POR_DEFECTO(),
        fechaFin: moment().format('yyyy-MM-DD'),
        idEstadoVigencia: 0,
        estadoVigencia: "",
        idEstado: 2,
        estado: "Activo",
        idPuntuacionPlanificacion: 2,
        puntuacionPlanificacion: "PCC",
        idPuntuacionAvance: 1,
        puntuacionAvance: "PCS",
        idModelo: 0,
        codigoModelo: "",
        modelo: "",
        idArea: 0,
        codigoArea: "",
        area: "",
        areaModelo: [],
        // Indicadores de detalle del criterio en la sesion (Si/No).
        detObjetivo: false,
        detCriterio: false,
        enunciadoReporte: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listEstadoVigencia: [{id: 0, descripcion: ""}],
    listEstado: [{id: 0, descripcion: ""}],
    // Los dos listados salen de la misma tabla (puntuacion) pero de clases
    // distintas de catalogo: 321 Sesiones de terapia alimenta la Escala de
    // avance y 322 Planificacion de terapia la Puntuacion Planificacion.
    // Van por separado para que cada cabecera no vea escalas de la otra.
    listPuntuacionAvance: [{id: 0, descripcion: ""}],
    listPuntuacionPlanificacion: [{id: 0, descripcion: ""}],
    listModelo: [{id: 0, descripcion: ""}],
    listPeriodicidades: [{id: 0, descripcion: ""}],
    // Areas del modelo elegido en la cabecera del plan.
    modeloArea: [],
    validationActive: {
        idTerapia: false,
        fechaInicio: false,
        fechaFin: false,
        idEstadoVigencia: false,
    },
    validationMessage: [],
  }

  export const therapyPlanSlice = createSlice({
    name: "therapyPlan",
    initialState,
    reducers: {
      setEntity: (state, action) => {
        state.entity = action.payload;
      },
      setData: (state, action) => {
        var { name, value } = action.payload;

        if (name.startsWith("id")) value = parseInt(value)

        state.entity[name] = value
        state.validationActive[name] = true
      },
      setValidationMessage: (state, action) => {
        state.validationMessage = action.payload;
      },
      activeValidations: (state, action) => {
        Object.keys(state.validationActive).forEach(function (key) {
          state.validationActive[key] = true;
        })
      },
      setListEstadoVigencia: (state, action) => {
        state.listEstadoVigencia = action.payload;
      },
      setListEstado: (state, action) => {
        state.listEstado = action.payload;
      },
      setListPuntuacionAvance: (state, action) => {
        state.listPuntuacionAvance = action.payload;
      },
      setListPuntuacionPlanificacion: (state, action) => {
        state.listPuntuacionPlanificacion = action.payload;
      },
      setListModelo: (state, action) => {
        state.listModelo = action.payload;
      },
      setListPeriodicidades: (state, action) => {
        state.listPeriodicidades = action.payload || [];
      },
      // Areas del modelo elegido en la cabecera del plan: alimentan el
      // autocompletado de Area.
      setModeloArea: (state, action) => {
        state.modeloArea = action.payload || [];
      },
    },
  });

  export const { setEntity, setData, setValidationMessage, activeValidations
    , setListEstadoVigencia, setListEstado
    , setListPuntuacionAvance, setListPuntuacionPlanificacion
    , setListModelo, setModeloArea, setListPeriodicidades } = therapyPlanSlice.actions;
  export default therapyPlanSlice.reducer;